/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import EventQuestionRoomsList from "./EventQuestionRoomsList";

export default EventQuestionRoomsList;
